import { memo } from 'react';
import styled from '@emotion/styled';

// Shown when the active application returns no chat contexts. The API only returns
// contexts whose application, chat context and primary agent are all published, so
// any of those being unpublished (or nothing being assigned) lands here.
export const ChatAgentsEmptyState = memo(() => {
  return (
    <Root role="status">
      <Title>No agents are available</Title>
      <Text>
        This application has no agents you can chat with. Check that the application, its agents and their chat
        contexts are published.
      </Text>
    </Root>
  );
});

const Root = styled.div({
  textAlign: 'center',
  padding: '35px 16px',
});

const Title = styled.div({
  color: 'var(--gray-d)',
  fontFamily: 'var(--font-semibold)',
});

const Text = styled.div({
  marginTop: 12,
  fontFamily: 'var(--font-reg)',
  color: 'var(--gray-d)',
});
